import React from 'react';
import ConfirmUserUpdate from '../ConfirmUserUpdate';
import {Alert, Button, FormGroup} from "reactstrap";
import TTLProxy from "../../common/TTLAsyncProxy";
import {UsersEndpoints} from "../../common/ProxyEndpoints";
import Utils from "../../common/Utils";
import PropTypes from 'prop-types';
import {ErrorMessage, Field, Form, Formik} from 'formik';
import * as Yup from 'yup';
import PhoneNumberInput from "../PhoneNumberInput/PhoneNumberInput";
import TokenInput from "../TokenInput/TokenInput";
import MDProgress from 'react-md-progress-bar';
import HTML from '../../common/HtmlHelpers';
import {ProgressHeader} from "./ConfirmUserUpdate";
import CodeInputView from "../CodeInputView/CodeInputView";

const TOKEN_LENGTH = 6;


class ChangePhoneNumber extends React.Component{

    static  propTypes = {
        onChanged: PropTypes.func,
        closeAfterChanged: PropTypes.bool
    };

    static defaultProps = {
        closeAfterChanged: true
    };

    constructor(props){
        super(props);

        this.state = ChangePhoneNumber.getInitialState();
        this.proxy = TTLProxy.getInstance();

        this.PhoneValidationSchema = Yup.object().shape({
            phone: Yup.string().required('Please provide your phone number')
                .test("phone","Please enter a valid phone number",(value) => Utils.validatePhoneNumber(value,this._enterPhoneForm.getFormikContext().values['phoneRegion']))
        });

        this.ConfirmationValidationSchema = Yup.object().shape({
            code: Yup.string().required('Enter the confirmation code received').min(TOKEN_LENGTH)
        });

    }

    static getInitialState(){

        return {
            hasInput: false,
            phone: "",
            confirmHintOpen: true,
            isBusy: false,
            errorMessage: null,
            agree: false
        };
    }

    show(){

        this.setState(ChangePhoneNumber.getInitialState(),() =>{
            this._confirmPhoneChange.show();
        });

    }

    onChangePhone({ phone , phoneRegion }){

        const formattedPhone = Utils.fixPhone(phone,phoneRegion);

        this.setState({
            isBusy: true,
            errorMessage: null,
            phone: formattedPhone
        });

        return this.proxy.processRequest( UsersEndpoints.confirmPhone(formattedPhone) ).then(response => {

            //
            if(response.ok){

                this.setState({
                    hasInput: true,
                    errorMessage: null
                });

            }

            this.setState({
                isBusy: false
            });

        }).catch(err => {

            this.setState({
                errorMessage: Utils.getResponseError(err),
                hasInput: false,
                isBusy: false
            });

        });

    }

    onConfirmPhoneChange({ code }){

        const newPhone = this.state.phone;
        const token = code;

        this.setState({
            isBusy: true,
            errorMessage: null
        });

        return this.proxy.processRequest(UsersEndpoints.changePhone(token, newPhone)).then(response =>{

            if(response.ok){

                HTML.toastSuccess('Phone number changed successfully');

                if(this.props.onChanged)
                    this.props.onChanged();

                if(this.props.closeAfterChanged)
                    this._confirmPhoneChange.toggle();

            }

            this.setState({
                isBusy: false
            });

        }).catch(err => {

            this.setState({
                isBusy: false,
                errorMessage: Utils.getResponseError(err)
            });


        });

    }


    renderTokenConfirm(){

        return (<Formik initialValues={{ code: '' }}
                        key="token-confirm-form"
                        validationSchema={this.ConfirmationValidationSchema}
                        onSubmit={async (values,{ setSubmitting}) =>{

                            try{
                                await this.onConfirmPhoneChange(values);
                            }
                            catch (e) {

                            }

                            setSubmitting(false);
                        }}>

            {({ isValid , isSubmitting }) => (<Form className="animated fadeIn" key="confirmForm">

                    <ProgressHeader title={"Confirmation"} step={2} maxSteps={2}/>
                    <Alert color={"info"} isOpen={this.state.confirmHintOpen} toggle={() => this.setState({ confirmHintOpen: !this.state.confirmHintOpen })}><b>Info:</b> You've been sent confirmation code. Enter code to proceed...</Alert>
                    <FormGroup>
                        <CodeInputView name="code" size={0.9}/>
                    </FormGroup>

                    {this.state.errorMessage && <p className="error-label">{this.state.errorMessage}</p>}


                <div>
                    {this.state.isBusy && <MDProgress show={true}/>}
                    <Button type="submit" block disabled={!isValid || this.state.isBusy} style={{borderRadius: 5}} color="green">Confirm <i className="fa fa-check"></i></Button>
                </div>

                </Form>)}
            </Formik>);

    }

    renderEnterInput(){

        return (<Formik initialValues={{ phone: "" }}
                        key="enter-phone-form"
                        validationSchema={this.PhoneValidationSchema}
                        ref={r => this._enterPhoneForm = r}
                        onSubmit={async (values,{ setSubmitting }) => {

                            try {
                                await this.onChangePhone(values);
                            }
                            catch (e) {

                            }

                            setSubmitting(false);
                        }}>
            {({ isValid , isSubmitting , errors  , touched }) => (<Form  key="inputForm">

                <ProgressHeader title={"Enter Phone Number"} step={1} maxSteps={2}/>
                <p>Please enter the new phone number below for verification. You'll be sent a confirmation code shortly for completing the process</p>

                <FormGroup>


                    <PhoneNumberInput disabled={isSubmitting}
                                      name={"phone"}
                                      inputClassName={"form-control form-input-select " + ((errors.phone && touched.phone) ? "form-input-error" : "")}
                                      includeRegion
                                      regionKey={"phoneRegion"}
                                      placeholder="Enter your new phone number here..."/>

                      <ErrorMessage name={"phone"} component={"div"} className={"error-hint"}/>
                </FormGroup>

                {this.state.errorMessage && <p className="error-label">{this.state.errorMessage}</p>}

                <div>
                    {this.state.isBusy && <MDProgress show={true}/>}
                    <Button type="submit" block disabled={!isValid || this.state.isBusy} style={{borderRadius: 5}} color="green">Verify <i className="icon-arrow-right"></i></Button>
                </div>

            </Form>)}

            </Formik>);
    }

    render(){

        const { agree } = this.state;

        return <ConfirmUserUpdate title="Change Phone No. Wizard"
                                  showCancelButton={false}
                                  ref={r => this._confirmPhoneChange = r}>

            {!agree ? <form className="text-center p-lg-4" onSubmit={(evt) => {
                        evt.preventDefault();
                        this.setState({
                            agree: true
                        });
                }}>

                    <span><i className="fa fa-phone fa-4x"/></span><br/>
                    <b>Change Phone Number</b>
                    <p className="mt-2">In order to change your phone number, we'll need you to verify that you truly own the number and can receive messages as well as make voice calls with it.</p>

                    <div style={{backgroundColor: "#ececec" , padding: 10 , marginBottom: 5}}>
                       Click the button below to begin...
                    </div>

                    <div className="text-center mt-2">

                        <Button block color={"green"}>Begin <i className="icon-arrow-right"/></Button>

                    </div>

            </form>: (this.state.hasInput ?  this.renderTokenConfirm() : this.renderEnterInput())}


        </ConfirmUserUpdate>

    }

}

export default ChangePhoneNumber;


// WEBPACK FOOTER //
// ./src/components/ConfirmUserUpdate/ChangePhoneNumber.js